import { EffectSimple } from './handlers/effect-simple';
import { EffectBalls } from './handlers/effect-balls';
import { EffectDiamonds } from './handlers/effect-diamonds';
import { EffectRefraction } from './handlers/effect-refraction';

import React from 'react'
const hndls = {
	'simple': EffectSimple,
	'balls': EffectBalls,
	'diamonds': EffectDiamonds,
	'refraction': EffectRefraction
}
function handlers(slug){
	return hndls[slug] ? hndls[slug] : ()=>(<h1>Error: Effect not found</h1>)
};
export default handlers
